module.exports = __webpack_public_path__ + "img/audi_thumbnail.bb03f472.png";